import React from 'react';
import useRegistroHorasLogic from './hooks/useRegistroHorasLogic';
import RegistroHorasView from './pages/RegistroHorasView';

export default function RegistroHoras() {
  const logic = useRegistroHorasLogic();
  return <RegistroHorasView {...logic} />;
}
